<template>
  <div class="page page-receive-coupon">
    <div class="card">
      <div class="header"
           v-if="coupon"
      >
        <span class="title">{{ coupon.title }}</span>
        <span class="price">¥{{ coupon.price }}</span>
        <span class="desc"
              v-if="coupon.typeDesc.length > 0"
        >
          {{ coupon.typeDesc }}
        </span>
        <span class="deadline">有效期至：{{ coupon.deadline|formatTime('yyyy年MM月dd日') }}</span>
      </div>
      <div class="content">
        <submit-form :receive-status="receive.status"
                     :receiver="receiver"
                     :render="render"
                     :id="id"
                     :code="code"
                     :share-path="$wechat.getWechatMenuShareAppLink()"
        ></submit-form>
      </div>
    </div>
  </div>
</template>

<script>
  import SubmitForm from '@/pages/Receive/components/SubmitForm';
  import { receiveCouponDetail } from '@/services/coupon';

  export default {
    name: 'ReceiveCoupon',
    metaInfo: {
      title: '领取优惠券',
    },
    components: {
      SubmitForm,
    },
    data() {
      return {
        receiver: null,
        render: null,
        coupon: null,
        code: '',
        id: '',
        receive: {
          status: '',
        },
      };
    },
    computed: {
      showSubmitForm() {
        return this.render && this.receiver && this.coupon;
      },
    },
    methods: {
      async getReceiveCouponInfo() {
        const data = await receiveCouponDetail(this.code, this.id);
        this.receiver = data.receiver;
        this.receive = data.receive;
        this.render = data.render;
        this.coupon = data.coupon;
      },
    },
    created() {
      if (JSON.stringify(this.$route.query) !== '{}') {
        this.code = this.$route.query.code;
      }
      if (JSON.stringify(this.$route.query) !== '{}') {
        this.id = this.$route.query.id;
      }
      this.getReceiveCouponInfo();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-receive-coupon {
    min-height: 100%;
    background-color: @background-color-base;
    padding: @size-base;
    img {
      width: 690px;
    }
  }

  .header {
    padding-top: @size-large;
    box-sizing: border-box;
    width: 690px;
    height: 370px;
    background: url("~@/assets/img/receive/coupon_bg.png") no-repeat;
    background-size: contain;
    color: @color-white;
    text-align: center;
    span {
      display: block;
      line-height: 1;
    }
  }
  .title {
    margin: 0 auto @size-small;
    font-size: @font-size-base;
  }
  .price {
    font-size: 100px;
  }
  .desc {
    width: fit-content;
    margin: @size-small auto 0;
    font-size: @font-size-base;
    position: relative;
    &:after {
      position: absolute;
      right: -76px;
      top: 50%;
      content: '';
      width: @size-large;
      height: 1px;
      background: @color-white;
    }
    &:before {
      position: absolute;
      left: -76px;
      top: 50%;
      content: '';
      width: @size-large;
      height: 1px;
      background: @color-white;
    }
  }
  .deadline {
    margin-top: @size-small + @size-extra-small / 2;
    font-size: @font-size-small;
    color: fade(@color-text-base, 50%);
  }
  .content {
    padding: @size-medium @size-base @size-extra-medium @size-base;
    border-radius: 0 0 @border-radius-medium @border-radius-medium;
    background: @color-white;
  }
  /deep/ .exchange-receiver-info {
    margin-top: 0;
  }
</style>
